<template>
  <i class="ri-close-line text-lg absolute right-2 top-0 text-[#000000] cursor-pointer" @click="onClickCancel"></i>
  <div class="w-full max-w-[50rem]">
    <!-- Header -->
    <div class="flex justify-center mb-3">
      <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_BASE_PATH}GAF.svg`" alt="GAF QuickMeasure"
        class="h-[89px] w-[89px]" />
    </div>

    <h2 class="text-[26px] text-[#464646] text-center font-semibold">
      {{ $t('gaf.header') }}
    </h2>
    <template v-if="connectButtonClicked">
      <Loader v-if="gafStore.loading" class="h-auto" />
      <AccountNotExist v-else />
    </template>

    <!-- VIEW 1: Connection Screen -->
    <template v-else>
      <Loader v-if="gafStore.loading" class="h-auto" />
      <div v-else>
        <div v-if="!gafStore.isConfigured"
          class="mt-4 mb-3 rounded-md border-1.5 md:w-[760px] p-3 border-[#D1D1D1] bg-[#F8F8F8]">
          <div class="flex gap-2 text-[#464646]">
            <i class="ri-error-warning-line text-xl"></i>
            <div>
              <span class="text-xl font-semibold">{{ $t('gaf.accountNotFound') }}</span>
              <div class="text-sm mt-1 w-full break-all">
                {{ gafStore.currentUserEmail }} {{ $t('gaf.accountNotExists') }}
              </div>
            </div>
          </div>
        </div>

        <p class="text-[#464646] text-base mb-14">
          {{ $t('gaf.footerMsg') }}
        </p>
      </div>
    </template>

    <!-- Footer -->

    <div v-if="!gafStore.loading" class="w-full flex justify-center mt-4"
      :class="connectButtonClicked ? 'sm:block' : 'block gap-1'">
      <button class="text-[#171717] text-base bg-[#fff] sm:inline-block sm:ml-2.5 mr-4 focus:outline-none"
        @click="onClickCancel">
        {{ $t('integration.cancel') }}
      </button>

      <!-- Connect Button-->
      <button v-if="!gafStore.loading && !connectButtonClicked" @click="onClickConnect"
        class="bg-[#762123] h-10 w-32 text-white font-inter text-base rounded disabled:opacity-50">
        <i class="ri-links-fill text-xl mr-1"></i>
        {{ $t('integration.connect') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useGafStore } from '@/stores/gafStore';
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_BASE_PATH } from "@/config/constants.js";
import Loader from '@/components/atoms/Loader.vue';
import AccountNotExist from '@/components/Reports/AccountNotExist.vue';
import { useI18n } from "vue-i18n";
import { getLanguage } from '@/utilities/cookies';

const { t, locale } = useI18n();
locale.value = getLanguage();

const emit = defineEmits(['close']);
const gafStore = useGafStore();

const connectButtonClicked = computed(() => gafStore.connectButtonClicked)

const onClickConnect = () => {
  gafStore.connectButtonClicked = true
  gafStore.connectAccount()
}

const onClickCancel = () => {
  emit('close')
}

</script>